import type {FC} from 'react';

import {useI18n} from '@yourcoach/i18n';

import type {Props} from './types';

import InfoSvg from '../../../../assets/icons/primary/Info Circle.svg';
import {Icon} from '../../../../uikit/Icon';
import * as S from './styles';

export const DisabledChannelsSectionHeader: FC<Props> = ({channelsCount}) => {
  const {t} = useI18n();

  return (
    <S.Container>
      <S.Title>{t('shared:disabled_chats')}</S.Title>
      <S.DescriptionContainer>
        <Icon color={'icon.gray'} svg={InfoSvg} />
        <S.Description>
          {t('shared:you_cant_message_to_archived_chats', {
            count: channelsCount,
          })}
        </S.Description>
      </S.DescriptionContainer>
    </S.Container>
  );
};
